module.exports = __webpack_public_path__ + "static/media/fortune-logo.b269c1d6.png";